module.exports = __webpack_public_path__ + "static/media/preview.70f32559.png";